<form [formGroup]="paymentSummaryForm" class="w-100" (ngSubmit)="payment()">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-column base-div">
    <pa-installment-options class="web-installment-options" *ngIf="paymentInformation?.installments?.length > 0"
                            [sdkInitTexts]="user?.sdkInitTexts"
                            [installmentOptions]="paymentInformation?.installments"
                            (installmentChange)="setInstallmentModel($event)"></pa-installment-options>
    <pa-installment-options-mobile class="mobile-installment-options"
                                   *ngIf="paymentInformation?.installments?.length > 0"
                                   [sdkInitTexts]="user?.sdkInitTexts"
                                   [installmentOptions]="paymentInformation?.installments"
                                   (installmentChange)="setInstallmentModel($event)"></pa-installment-options-mobile>
    <div class="col-12 px-0" *ngIf="paymentInformation?.installments?.length > 0">
      <div class="installment-path"></div>
    </div>
    <div class="col-12 px-0 m-top">
      <label
        class="summary-title">{{this.textService.keyValueMapping('summaryHeader', 'İşlem Özeti', user?.sdkInitTexts)}}</label>
    </div>
    <div class="col-12 px-0 first-div">
      <label class="information-title"
             *ngIf="paymentInformation == null">{{this.textService.keyValueMapping('transactionAmountLabel', 'Ürün Toplamı:', user?.sdkInitTexts)}}
        <span
          class="text-style">₺{{(this.paymentModelInformation?.amount / 100 | amount)}}</span></label>
      <label class="information-title"
             *ngIf="paymentInformation != null && paymentInformation?.paymentMethodType!='DCB'">{{this.textService.keyValueMapping('transactionAmountLabel', 'Ürün Toplamı:', user?.sdkInitTexts)}}
        <span
          class="text-style">₺{{(this.amount / 100 | amount)}}</span></label>
      <label class="information-title"
             *ngIf="paymentInformation?.paymentMethodType==='DCB'">{{this.textService.keyValueMapping('transactionAmountLabel', 'Ürün Toplamı:', user?.sdkInitTexts)}}
        <span
          class="text-style">₺{{(this.amount / 100 | amount)}}</span></label>
    </div>
    <div class="col-12 px-0"
         *ngIf="paymentInformation?.paymentMethodType=='DCB' && paymentInformation?.calculatedFeeAmount">
      <label
        class="information-title">{{this.textService.keyValueMapping('transactionFeeLabel', 'İşlem Ücreti:', user?.sdkInitTexts)}}
        <span
          class="text-style">₺{{(paymentInformation?.calculatedFeeAmount | amount)}}</span></label>
    </div>
    <div class="col-12 px-0" *ngIf="this.checkEMoney(paymentInformation) > 0">
      <label
        class="information-title">{{this.textService.keyValueMapping('transactionEmoneyLabel', 'Hediye Para:', user?.sdkInitTexts)}}
        <span
          class="text-style">-₺{{(this.checkEMoney(paymentInformation) | amount)}}</span></label>
    </div>
    <div class="col-12 px-0">
      <div class="path"></div>
    </div>
    <div class="contracts">
      <div class="col-12 px-0 d-flex checkbox-div" *ngIf="paymentInformation?.paymentMethodType==='DCB' && dcbTextShow">
        <mat-checkbox class="checkbox-style" formControlName="dcbOpen"><label class="checkbox-description">
          {{this.textService.keyValueMapping('activateDcbText', 'Hattımın Faturana Yansıt Limit kullanımına açılmasını istiyorum.', user?.sdkInitTexts)}}</label>
        </mat-checkbox>
      </div>
      <div class="col-12 px-0 d-flex checkbox-div" *ngIf="paymentModelInformation?.showEula && !this.showCardAgreement">
        <mat-checkbox class="checkbox-style" formControlName="eulaAgreement"><label
          class="checkbox-description"><a><span
          class="text-style"
          (click)="createAccountEulaModal()">{{this.textService.keyValueMapping('paycellWarningAcceptAggrementPart1', 'Çerçeve Ödeme Hizmetleri Sözleşmesi', user?.sdkInitTexts)}}</span></a>
          {{this.textService.keyValueMapping('paycellWarningAcceptAggrementPart4', '\'ni kabul ediyorum.', user?.sdkInitTexts)}}
        </label>
        </mat-checkbox>
      </div>
      <div class="col-12 px-0 d-flex checkbox-div" *ngIf="this.showCardAgreement && !paymentModelInformation?.showEula">
        <mat-checkbox class="checkbox-style" formControlName="cardAgreement"><label
          class="checkbox-description"><a><span
          class="text-style"
          (click)="createCardEulaModal()">{{this.textService.keyValueMapping('paycellWarningAcceptAggrementPart3', 'Kart Saklama Sözleşmesi', user?.sdkInitTexts)}}</span></a>
          {{this.textService.keyValueMapping('paycellWarningAcceptAggrementPart4', '\'ni kabul ediyorum.', user?.sdkInitTexts)}}
        </label>
        </mat-checkbox>
      </div>
      <div class="col-12 px-0 d-flex checkbox-div" *ngIf="paymentModelInformation?.showEula && this.showCardAgreement">
        <mat-checkbox class="checkbox-style" formControlName="cardAndEulaAgreement"><label
          class="checkbox-description">{{this.textService.keyValueMapping('paycellPlease', 'Lütfen', user?.sdkInitTexts)}}
          <a><span
            class="text-style"
            (click)="createAccountEulaModal()">{{this.textService.keyValueMapping('paycellWarningAcceptAggrementPart1', 'Çerçeve Ödeme Hizmetleri Sözleşmesi', user?.sdkInitTexts)}}</span></a>
          {{this.textService.keyValueMapping('paycellWarningAcceptAggrementPart2', '\'ni ve', user?.sdkInitTexts)}}
          <a><span
            class="text-style"
            (click)="createCardEulaModal()">{{this.textService.keyValueMapping('paycellWarningAcceptAggrementPart3', 'Kart Saklama Sözleşmesi', user?.sdkInitTexts)}}</span></a>
          {{this.textService.keyValueMapping('paycellWarningAcceptAggrementPart4', '\'ni kabul ediyorum.', user?.sdkInitTexts)}}
        </label>
        </mat-checkbox>
      </div>
      <div class="col-12 px-0 d-flex checkbox-div" *ngIf="paymentInformation?.giftMoneys[0] != null">
        <mat-checkbox class="checkbox-style" formControlName="giftMoneyUsage"><label
          class="checkbox-description"> {{paymentInformation?.giftMoneys[0]?.amount | n11Amount}}
          {{this.textService.keyValueMapping('paycellHPUsageConfirm', 'TL Hediye Paramı kullanmak istiyorum.', user?.sdkInitTexts)}}</label>
        </mat-checkbox>
      </div>
    </div>
    <div class="col-12 px-0 d-flex payment-amount">
      <label class="total"
             *ngIf="paymentInformation == null">{{this.textService.keyValueMapping('transactionTotalAmountHeader', 'Toplam:', user?.sdkInitTexts)}}
        ₺{{(this.paymentModelInformation?.amount / 100 | amount)}}</label>
      <label class="total"
             *ngIf="paymentInformation != null && paymentInformation?.paymentMethodType!='DCB'">{{this.textService.keyValueMapping('transactionTotalAmountHeader', 'Toplam:', user?.sdkInitTexts)}}
        ₺{{(this.amount / 100 | amount)}}</label>
      <label class="total"
             *ngIf="paymentInformation?.paymentMethodType==='DCB' &&  !paymentInformation?.calculatedFeeAmount">{{this.textService.keyValueMapping('transactionTotalAmountHeader', 'Toplam:', user?.sdkInitTexts)}}
        ₺{{((this.amount / 100) - this.checkEMoney(this.paymentInformation) | amount)}}</label>
      <label class="total"
             *ngIf="paymentInformation?.calculatedFeeAmount && paymentInformation?.paymentMethodType==='DCB'">{{this.textService.keyValueMapping('transactionTotalAmountHeader', 'Toplam:', user?.sdkInitTexts)}}
        ₺{{(((this.amount / 100) + paymentInformation?.calculatedFeeAmount) - this.checkEMoney(this.paymentInformation) | amount)}}</label>
      <button
        [ngClass]="(paymentModelInformation!= null && paymentInformation?.availableMethod && paymentSummaryForm.valid && this.buttonActivated) ? 'button-style':'button-style-passive'"
        [disabled]="paymentModelInformation!= null && !paymentInformation?.availableMethod || paymentSummaryForm.invalid || !this.buttonActivated"><span
        class="text-style">{{this.textService.keyValueMapping('makePaymentButton', 'Ödeme Yap', user?.sdkInitTexts)}}</span>
      </button>
    </div>
  </div>
</form>
